// import * as CryptoJS from "crypto-js";
// import Moment from "moment";
import { encryptV2 } from "../helpers/Cryptography/CryptoV2";

// const key = CryptoJS.enc.Utf8.parse("M@h1ndra$1234567");

// const iv = CryptoJS.enc.Utf8.parse("0001000100010001");
// let key = CryptoJS.enc.Utf8.parse(Moment().format("DDMMYYYY"));
// let iv = CryptoJS.enc.Utf8.parse(Moment().format("YYYYMMDD"));

const Encrypt = (plainData) => {
  return encryptV2(plainData);
  // let encrypted = CryptoJS.AES.encrypt(plainData, key, {
  //   keySize: 128 / 8,

  //   iv: iv,

  //   mode: CryptoJS.mode.CBC,

  //   padding: CryptoJS.pad.Pkcs7,
  // }).toString();

  // let decryptedText = encrypted.toString(CryptoJS.enc.Utf8);

  // return decryptedText;
};

export default Encrypt;
